import { Button, DatePicker, Input, Space } from "antd";
import { FilterFilled, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { handleAllowNumbersOnly } from "./helpfulFunctions";
const { RangePicker } = DatePicker;

export const antdTheme = {
  token: {
    fontFamily: "Roboto",
    colorBorder: "#D9D9D9",
    colorPrimaryText: "#F5F5F5",
    colorError: "#e72121",
    colorErrorHover: "#e72121",
  },
  components: {
    Input: {
      colorText: "#0f3264",
      fontSize: 16,
      controlHeight: 30,
      colorTextPlaceholder: "#00000040",
    },
    InputNumber: {
      colorText: "#0f3264",
      fontSize: 16,
      controlHeight: 30,
      colorTextPlaceholder: "#00000040",
    },
    Select: {
      controlHeight: 30,
      colorText: "#0f3264",
      fontSize: 16,
    },
  },
};

export const iconColors = {
  initial: "#b4b4b4",
  active: "#1677ff",
};

export const customizeColumnSearch = (
  searchText,
  searchedColumn,
  handleSearch,
  handleReset,
  fieldsAcceptNumbersOnly = [],
  filterByAPI = false
) => {
  return (dataIndex, searchPlaceholderText) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          autoFocus
          className="grid-table__search-input"
          placeholder={`Search ${searchPlaceholderText || dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onKeyDown={(e) => {
            if (fieldsAcceptNumbersOnly.includes(dataIndex)) {
              handleAllowNumbersOnly(e, true);
            }
          }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
            minHeight: "32px",
          }}
        />
        <Space className="flex-wrap">
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
              backgroundColor: "#176b87",
            }}
          >
            Search
          </Button>
          <Button
            onClick={() =>
              clearFilters && handleReset(clearFilters, dataIndex, confirm)
            }
            size="small"
            style={{
              width: 90,
              color: "#e72121",
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ color: filtered ? iconColors.active : iconColors.initial }}
      />
    ),
    onFilter: (value, record) => {
      // Handle nested path
      const keys = Array.isArray(dataIndex) ? dataIndex : [dataIndex];
      const nestedValue = keys.reduce((obj, key) => (obj || {})[key], record);

      return filterByAPI
        ? true
        : nestedValue
        ? nestedValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
    render: (text) => {
      const isSearchColumnArr = Array.isArray(searchedColumn);
      const searchedColumnTitle = isSearchColumnArr
        ? searchedColumn.join(".")
        : searchedColumn;
      const isDataIndexArr = Array.isArray(dataIndex);
      const searchedDataIndex = isDataIndexArr
        ? dataIndex.join(".")
        : dataIndex;
      return searchedColumnTitle === searchedDataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      );
    },
  });
};

export const customizeColumnDateFilter = (selectedRange, handleDateChange) => {
  return () => ({
    filterDropdown: () => (
      <div
        style={{
          padding: 8,
        }}
        className="range-picker-holder"
        onKeyDown={(e) => e.stopPropagation()}
      >
        <RangePicker
          value={selectedRange}
          allowClear
          popupClassName="main-date-picker"
          inputReadOnly={false}
          onChange={handleDateChange}
          onKeyDown={(e) => e.preventDefault()}
        />
      </div>
    ),
    filterResetToDefaultFilteredValue: true,
    filterIcon: () => (
      <FilterFilled
        style={{
          color: selectedRange?.length ? iconColors.active : iconColors.initial,
        }}
      />
    ),
    render: (text) => text,
  });
};
